import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import { PAStandardQuantity } from "./types";

export const paStandardQuantityListService = (params: {
  page?: number | null;
  limit?: number | null;
  status?: number | null;
  keyword?: string | null;
  month?: number | null;
  year?: number | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<PAStandardQuantity>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const paStandardQuantityListShortService = (params: {
  keyword?: string | null;
  code?: string | null;
  name?: string | null;
  page?: number | null;
  limit?: number | null;
  status?: number | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<PAStandardQuantity>>({
    method: HTTPRequestMethods.GET,
    url: Paths.Short,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const paStandardQuantityCreateService = (params: {
  effectiveFrom: string;
  machineId: string;
  productId: string;
  unit: string;
  standardProductivityPerHour: number;
  standardProductivityPerDay: number;
  standardProductivityPerMonth: number;
  workerPerMachine: number;
}) =>
  RestAPIClient.call<PAStandardQuantity>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const paStandardQuantityUpdateService = ({
  id,
  ...rest
}: Parameters<typeof paStandardQuantityCreateService>[0] & {
  id: string;
  status?: number;
}) =>
  RestAPIClient.call<PAStandardQuantity>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${String(id)}`,
    config: {
      requireAuthentication: true,
    },
    data: rest,
  });

export const paStandardQuantityDetailService = (id: string) =>
  RestAPIClient.call<PAStandardQuantity>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const paStandardQuantityDeleteService = (id: string) =>
  RestAPIClient.call<PAStandardQuantity>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Delete}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const paStandardQuantitySyncService = (params: {
  month?: number | null;
  year?: number | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<PAStandardQuantity>>({
    method: HTTPRequestMethods.GET,
    url: Paths.Sync,
    config: {
      requireAuthentication: true,
      params,
    },
  });
